// extracted by mini-css-extract-plugin
export default {"data":"styles_data__RNxVt","name":"styles_name__1ZS6e","address":"styles_address__V9Iaf","button":"styles_button__AtOh6"};